import React from 'react';
import { arrayOf, bool, func, oneOfType, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import FirstPage from './FirstPage';
import { toggleModal as toggleModalAction } from './redux/actions/uiActions';

export function FirstPageContainer({
  country,
  countryOptions,
  experienced,
  entityTypeOptions,
  isDuplicatePartner,
  nextPage,
  partner,
  referral,
  referralOptions,
  serviceCountryOptions,
  showModal,
  stateOptions,
  toggleModal
}) {
  const shouldAsyncValidate = ({
    blurredField,
    syncValidationPasses,
    trigger
  }) => {
    if (trigger === 'blur') {
      if (
        blurredField === 'business_phone' ||
        blurredField === 'primary_contact_email'
      )
        return true;
    }
    if (!syncValidationPasses) return false;
    if (trigger === 'blur' || trigger === 'submit') return true;
    return false;
  };

  const handleNextPageClick = () => isDuplicatePartner && toggleModal(true);
  const handleModalClose = () => toggleModal();

  return (
    <FirstPage
      country={country}
      countryOptions={countryOptions}
      entityTypeOptions={entityTypeOptions}
      experienced={experienced}
      initialValues={
        partner || {
          category_ids: [],
          category_details: []
        }
      }
      onSubmit={nextPage}
      handleModalClose={handleModalClose}
      handleNextPageClick={handleNextPageClick}
      referral={referral}
      referralOptions={referralOptions}
      serviceCountryOptions={serviceCountryOptions}
      shouldAsyncValidate={shouldAsyncValidate}
      showModal={showModal}
      stateOptions={stateOptions}
    />
  );
}

FirstPageContainer.propTypes = {
  country: string,
  countryOptions: arrayOf(shape({})).isRequired,
  experienced: oneOfType([bool, string]),
  entityTypeOptions: arrayOf(shape({})).isRequired,
  isDuplicatePartner: bool.isRequired,
  nextPage: func.isRequired,
  partner: shape({}),
  referral: string,
  referralOptions: arrayOf(shape({})).isRequired,
  serviceCountryOptions: arrayOf(shape({})).isRequired,
  showModal: bool.isRequired,
  stateOptions: arrayOf(shape({})).isRequired,
  toggleModal: func.isRequired
};

FirstPageContainer.defaultProps = {
  country: undefined,
  experienced: false,
  partner: undefined,
  referral: ''
};

const mapStateToProps = ({
  meta: {
    countryOptions,
    entityTypeOptions,
    isDuplicatePartner,
    partner,
    referralOptions,
    serviceCountryOptions,
    stateOptions
  },
  ui: { showModal },
  ...state
}) => {
  const selector = formValueSelector('partnerSubmissionForm');
  const selection = selector(state, 'country', 'experienced', 'referral');

  return {
    countryOptions,
    entityTypeOptions,
    isDuplicatePartner,
    partner,
    referralOptions,
    ...selection,
    serviceCountryOptions,
    showModal,
    stateOptions
  };
};

export default connect(mapStateToProps, { toggleModal: toggleModalAction })(
  FirstPageContainer
);
